import application_settings from '../applicationSettings';
import Event from './Event';

class EditAddress extends Event {
  eventName = "oms_editAddress";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @return void
   *
   */
  eventFunction(data) {
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";
    let dataObj = data.data ? data.data : "";
      
    data.endPoint = application_settings.endPoints.editAddress;
    data.method = 'POST';
    data.canUsePublicAuth = false;
    data.data = dataObj;

    this.sendRequest(data, function (response) {
      if (response) {
        //format response data
        let data = thisObj.formatResponseData(response);

        //fire success event
        thisObj.onSuccessEvent(data, {
          action: action,
          request_id: requestId,
        });
      }
    });
  }
}

export default EditAddress;